import { useState, useEffect } from 'react';
import { useAuthContext } from '../auth/contexts/AuthContext';
import { Consent, getGdprConsent } from '../helpers/CookieConsentHelper';
import { featureFlags } from '../config/envConfig';

const useIsGdprConsent = () => {
  const {
    showCookies,
    consentVersion,
  } = useAuthContext();
  const [consent, setConsent] = useState<Consent>(
    !featureFlags.cookieConsent ? { analytics: true, functional: true } : getGdprConsent()
  );

  useEffect(() => {
    if (!featureFlags.cookieConsent) return;
    const consentLocal = getGdprConsent();
    setConsent(consentLocal);
  }, [showCookies, consentVersion]);

  return { consent };
};

export default useIsGdprConsent;